import React from 'react';
import cn from 'classname';
import './main.less';

import { withRouter, Link } from 'react-router';

import withIntl from '../../../intl-hoc';
import withCheckPermission from '../../../check-permission-hoc';

function ContentHead({ intl, check, name, tabs, location }) {
	return !!(name || tabs) && (
		<div className='page-container--content-head'>
			{name && (
				<div className='page-container--content-head--name'>
					<h2>{intl(name)}</h2>
				</div>
			)}
			{tabs && (
				<div className='page-container--content-head--tabs'>
					{tabs.map((tab, i) => {
						return !(tab.permission && !check(tab.permission)) && (
							<Link
								className={cn('page-container--content-head--tab', {
									active: location.pathname.includes(tab.href)
								})}
								to={tab.href}
								key={i}
							>
								<span>{intl(tab.name)}</span>
							</Link>
						);
					})}
				</div>
			)}
		</div>
	);
}

export default withIntl(withCheckPermission(withRouter(ContentHead)));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/page-container/components/content-head/main.js